"use client";

import { ArrowLeft, ArrowRight, ExternalLink } from "lucide-react";
import { useEffect, useState } from "react";

import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { ctaLinks } from "./site-content";

const representativeNaverReviews = [
  {
    id: "neuro-rehab",
    category: "신경계 재활",
    summary: "뇌졸중 이후 좌측 편마비, 재활병원 퇴원 후 재활운동을 이어간 후기",
    visitor: "단코니아",
    date: "2026.05.28",
    rating: 5,
    quote:
      "오재운완!! 오늘 재활운동 완료했습니다\n\n뇌졸중으로 쓰러지고 재활병원을 전전하며 전원하고 다니다 퇴원 후에도 계속 재활운동을 이어가야겠다는 생각으로 노원 주변에 재활운동 잘하는 곳을 알아보다가 재활병원에 있을때 같은 병실에서 입원했었던 지인의 추천으로 모티오나 재활운동센터에 방문하게 되었습니다\n\n처음에는 좌측 편마비로 인한 불편함도 많고 일상생활에서도 어려운 부분이 있었는데 상민 선생님께 재활운동을 받고 난 후 점점 일상생활과 몸의 움직임이 좋아지는 것을 느꼈습니다\n\n상민 선생님이 너무 친절하시고 어떤식으로 운동해야 하는지 집에서 혼자서 운동하는 방법도 잘 알려주셨어요\n\n선생님이 알려주시는 방식에 맞춰서 잘 따라가다보면 일상생활도 예전보다 훨씬 편하게 할수 있을것 같네요\n\n생긴지 얼마 되지않아 운동기구 쌔것",
    tags: ["퇴원 후 재활", "편마비", "홈 운동"],
  },
  {
    id: "gait-change",
    category: "보행 변화",
    summary: "소아마비 이후 걸음걸이와 절뚝거림이 고민이었던 사례",
    visitor: "말달구지",
    date: "2026.06.02",
    rating: 5,
    quote:
      "어릴 때 소아마비를 앓은 뒤 걸음걸이, 절뚝거림, 다리 길이와 근력 차이 때문에 고민이 많았습니다. 단순히 근력운동만 하기보다 어떤 근육을 잘 못 쓰는지, 걸을 때 어디에 힘을 줘야 하는지 알고 싶어 모티오나 재활운동센터에 방문했습니다. 이상민 선생님께 20회 등록하고 이제 10회차 정도 받았는데, 매번 몸 상태에 맞게 자세히 봐주시고 설명도 쉽게 해주셔서 좋았습니다. 운동 후에는 몸이 개운하고, 걸을 때 힘 쓰는 부분도 더 잘 느껴집니다. 원래 5분 이상 걸으면 고관절 통증이 올라왔는데 요즘은 통증이 늦게 오고 강도도 많이 줄었습니다. 아직 갈 길은 있지만 몸을 쓰는 느낌이 달라진 건 확실히 느낍니다.",
    tags: ["보행", "근력 차이", "체중지지"],
  },
  {
    id: "shoulder-pain",
    category: "근골격계 통증",
    summary: "어깨 석회화와 통증으로 정형외과 진료 후 운동 방향을 찾은 후기",
    visitor: "꿈별잉",
    date: "2026.06.05",
    rating: 5,
    quote:
      "3주 전에 좌측 어깨 통증이 시작됐어요. 파스를 일주일 넘게 붙여봤는데 나아지기는 커녕 계속 아파서 정형외과를 찾았어요. 검사결과 어깨에 석회가 생겼다는걸 알게 되었어요. 병원에서 몇 가지 스트레칭 동작을 알려줘서 집에서 시도해 봤는데 아프기만 하고 제대로 하는건지 잘 모르겠더라구요. 이런 부분의 도움은 어디서 받는게 좋을까 생각하던 차에 모티오나 재활운동센터의 이상민 대표님께 도움을 받게 되었어요. 저의 건강을 진심으로 걱정해주시며 회복을 위한 여러가지 동작을 알려주었어요. 한 동작을 하면 아프지 않던 다른 부위가 새롭게 아팠는데 그때마다 해결책을 바로 제시해주었어요. 전문가는 역시 다르구나 싶은 생각이 들었어요.  병원 치료와 병행하면 더 빨리 나을것 같다는 생각이 들었어요.",
    tags: ["어깨 석회화", "운동 방향", "병원 치료 병행"],
  },
  {
    id: "visit-rehab",
    category: "방문재활운동",
    summary: "바쁜 일정으로 센터 방문이 어려웠던 분의 허리 통증 방문재활 후기",
    visitor: "엠브리87",
    date: "2026.06.08",
    rating: 5,
    quote:
      "평소 일이 바빠서 운동센터에 갈 시간이 없었는데, 꽤 먼 거리임에도 직접 집까지 출장 와주셔서 정말 편하게 받을 수 있었습니다. 단순히 허리만 운동하는 것이 아니라 왜 통증이 생기는지, 어떤 움직임을 바꿔야 하는지 이해하기 쉽게 설명해 주셨습니다.\n브릿지, 버드독, 사이드 플랭크 같은 동작을 통해 허리로만 버티던 습관을 줄이고 고관절, 햄스트링, 코어 근육을 함께 사용하는 방법을 배웠습니다. 운동 하나하나의 목적을 알려주셔서 따라 하기 쉬웠고, 몸의 중심을 잡는 느낌도 받을 수 있었습니다.\n무엇보다 시간 내서 센터를 방문할 필요 없이 집에서 전문적인 지도를 받을 수 있어 만족스러웠고, 꾸준히 하면 일상생활에서 허리 부담과 통증을 줄이는 데 도움이 될 것 같아 만족합니다. 추천드립니다!!",
    tags: ["방문재활", "허리 통증", "코어 운동"],
  },
] as const;

const stars = Array.from({ length: 5 });

export function ReviewProofSection() {
  const [carouselApi, setCarouselApi] = useState<CarouselApi>();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [expandedReviewIds, setExpandedReviewIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!carouselApi) {
      return;
    }

    const updateSelection = () => {
      setCurrentSlide(carouselApi.selectedScrollSnap());
      setCanScrollPrev(carouselApi.canScrollPrev());
      setCanScrollNext(carouselApi.canScrollNext());
    };

    updateSelection();
    carouselApi.on("reInit", updateSelection);
    carouselApi.on("select", updateSelection);

    return () => {
      carouselApi.off("reInit", updateSelection);
      carouselApi.off("select", updateSelection);
    };
  }, [carouselApi]);

  const toggleExpanded = (reviewId: string) => {
    setExpandedReviewIds((current) => {
      const next = new Set(current);
      if (next.has(reviewId)) {
        next.delete(reviewId);
      } else {
        next.add(reviewId);
      }
      return next;
    });
  };

  return (
    <section className="review-showcase relative overflow-hidden px-4 py-18 text-[#050505] md:px-6 md:py-24">
      <div className="mx-auto max-w-[1180px]">
        <div className="grid gap-5 border-b border-[#050505]/14 pb-8 md:grid-cols-[0.9fr_1.1fr] md:items-end md:pb-10">
          <div>
            <p className="text-sm font-black text-[#8c0000]">실제 네이버 예약 리뷰</p>
            <h2 className="mt-3 max-w-2xl text-[2.35rem] font-black leading-[1.1] md:text-[4.2rem]">
              재활운동을 경험한 분들의
              <br />
              변화 기록입니다.
            </h2>
          </div>
          <div className="flex flex-col gap-4 md:items-end">
            <p className="max-w-xl text-base font-bold leading-8 text-[#4d3a00] md:text-lg md:leading-9 md:text-right">
              신경계 재활, 보행 변화, 근골격계 통증, 방문재활 사례를 실제 네이버 리뷰 원문으로 정리했습니다.
            </p>
            <div className="hidden gap-2 md:flex">
              <button
                type="button"
                onClick={() => carouselApi?.scrollPrev()}
                disabled={!canScrollPrev}
                className="inline-flex size-11 items-center justify-center rounded-full border border-[#050505]/16 bg-[#fffdf2] text-[#050505] shadow-[0_10px_24px_rgba(80,54,0,0.1)] transition hover:-translate-y-0.5 hover:bg-white disabled:cursor-not-allowed disabled:opacity-38 disabled:hover:translate-y-0"
                aria-label="이전 네이버 리뷰 보기"
              >
                <ArrowLeft className="size-5" aria-hidden="true" />
              </button>
              <button
                type="button"
                onClick={() => carouselApi?.scrollNext()}
                disabled={!canScrollNext}
                className="inline-flex size-11 items-center justify-center rounded-full border border-[#050505]/16 bg-[#fffdf2] text-[#050505] shadow-[0_10px_24px_rgba(80,54,0,0.1)] transition hover:-translate-y-0.5 hover:bg-white disabled:cursor-not-allowed disabled:opacity-38 disabled:hover:translate-y-0"
                aria-label="다음 네이버 리뷰 보기"
              >
                <ArrowRight className="size-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-10">
          <Carousel
            setApi={setCarouselApi}
            opts={{
              align: "center",
              containScroll: "trimSnaps",
            }}
            aria-label="대표 네이버 예약 리뷰"
          >
            <CarouselContent className="ml-0">
              {representativeNaverReviews.map((review) => {
                const expanded = expandedReviewIds.has(review.id);

                return (
                  <CarouselItem key={review.id} className="basis-full pl-0">
                    <article className="mx-auto flex min-h-[34rem] max-w-[920px] flex-col rounded-[8px] border border-[#050505]/14 bg-[#fffdf2]/92 p-5 shadow-[0_18px_44px_rgba(80,54,0,0.12)] backdrop-blur md:min-h-[32rem] md:p-8">
                      <div className="flex flex-wrap items-start justify-between gap-4">
                        <div>
                          <p className="inline-flex rounded-full border border-[#8c0000]/18 bg-[#fff0a8] px-3 py-1 text-xs font-black text-[#8c0000]">
                            {review.category}
                          </p>
                          <h3 className="mt-4 max-w-2xl text-2xl font-black leading-[1.18] text-[#050505] md:text-[2.6rem]">
                            {review.summary}
                          </h3>
                        </div>
                        <p className="text-sm font-black text-[#050505]/38" aria-hidden="true">
                          {String(currentSlide + 1).padStart(2, "0")}
                        </p>
                      </div>

                      <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-2 border-y border-[#050505]/10 py-4 text-sm font-bold text-[#4d3a00]">
                        <p className="font-black text-[#050505]">{review.visitor} 님</p>
                        <span aria-hidden="true">/</span>
                        <time dateTime={review.date.replaceAll(".", "-")}>{review.date}</time>
                        <span aria-hidden="true">/</span>
                        <div className="inline-flex items-center gap-1" aria-label={`별점 ${review.rating}점`}>
                          {stars.map((_, starIndex) => (
                            <span
                              key={starIndex}
                              className={starIndex < review.rating ? "text-[#ffc917]" : "text-[#050505]/16"}
                              aria-hidden="true"
                            >
                              ★
                            </span>
                          ))}
                        </div>
                      </div>

                      <p
                        className={`mt-6 whitespace-pre-line text-base font-bold leading-8 text-[#2f2600] md:text-lg md:leading-9 ${
                          expanded ? "" : "line-clamp-5"
                        }`}
                      >
                        {review.quote}
                      </p>

                      <button
                        type="button"
                        onClick={() => toggleExpanded(review.id)}
                        className="mt-4 self-start text-sm font-black text-[#8c0000] underline decoration-[#8c0000]/28 underline-offset-4 transition hover:text-[#050505]"
                        aria-expanded={expanded}
                      >
                        {expanded ? "원문 접기" : "원문 더보기"}
                      </button>

                      <div className="mt-auto flex flex-wrap gap-2 pt-6">
                        {review.tags.map((tag) => (
                          <span
                            key={tag}
                            className="rounded-full bg-[#fff0a8] px-3 py-1 text-xs font-black text-[#4d3a00]"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </article>
                  </CarouselItem>
                );
              })}
            </CarouselContent>
          </Carousel>

          <div className="mt-7 flex items-center justify-center gap-4">
            <div className="flex items-center gap-2">
              {representativeNaverReviews.map((review, index) => (
                <button
                  key={review.id}
                  type="button"
                  onClick={() => carouselApi?.scrollTo(index)}
                  className={`size-2.5 rounded-full transition ${
                    currentSlide === index ? "bg-[#8c0000]" : "bg-[#050505]/18 hover:bg-[#050505]/32"
                  }`}
                  aria-label={`${index + 1}번째 네이버 리뷰 보기`}
                  aria-current={currentSlide === index ? "step" : undefined}
                />
              ))}
            </div>
            <p className="min-w-12 text-sm font-black text-[#4d3a00]" aria-live="polite">
              {currentSlide + 1}/{representativeNaverReviews.length}
            </p>
          </div>
        </div>

        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <a
            href={ctaLinks.reviews}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-11 items-center justify-center rounded-[8px] border-2 border-[#050505] bg-[#03c75a] px-5 text-sm font-black text-[#050505] shadow-[4px_4px_0_rgba(5,5,5,0.18)] transition hover:-translate-y-0.5 hover:bg-[#00b956]"
          >
            네이버 리뷰 전체 보기
            <ExternalLink className="ml-2 size-4" aria-hidden="true" />
          </a>
          <a
            href={ctaLinks.centerSms}
            className="inline-flex min-h-11 items-center justify-center rounded-[8px] border-2 border-[#050505] bg-[#fffdf2] px-5 text-sm font-black text-[#050505] shadow-[4px_4px_0_rgba(140,0,0,0.16)] transition hover:-translate-y-0.5 hover:bg-white"
          >
            상담하기
          </a>
        </div>

        <p className="mx-auto mt-6 max-w-3xl border-t border-[#050505]/14 pt-5 text-center text-sm font-bold leading-7 text-[#4d3a00]/78">
          개인 경험을 바탕으로 한 참고 자료입니다. 의료적 판단이 필요한 증상은 병원 진료를 우선합니다.
        </p>
      </div>
    </section>
  );
}
